"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiDropMetadataResponse } from "@/generated/models/ApiDropMetadataResponse";
import { TOOLTIP_STYLES, buildTooltipId } from "@/helpers/tooltip.helpers";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import { useState } from "react";
import { Tooltip } from "react-tooltip";
interface ParticipationDropMetadataProps {
  readonly metadata: ApiDropMetadataResponse[];
  readonly contextId?: string | number | undefined;
}

// Component to display individual metadata items in cards
const MetadataItem: React.FC<{
  readonly meta: ApiDropMetadataResponse;
  readonly contextId?: string | number | undefined;
}> = t0 => {
  const $ = _c(18);
  const {
    meta,
    contextId
  } = t0;
  const isMobile = useIsMobileDevice();
  let t1;
  if ($[0] !== contextId || $[1] !== meta.data_key) {
    t1 = buildTooltipId("metadata", contextId, meta.data_key);
    $[0] = contextId;
    $[1] = meta.data_key;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tooltipId = t1;
  let t2;
  if ($[3] !== meta.data_key) {
    t2 = <span className="tw-mr-1.5 tw-text-xs tw-text-iron-400">{meta.data_key}:</span>;
    $[3] = meta.data_key;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== meta.data_value || $[6] !== tooltipId) {
    t3 = <span className="tw-line-clamp-2 tw-text-xs tw-font-medium tw-text-iron-200" data-tooltip-id={tooltipId}>{meta.data_value}</span>;
    $[5] = meta.data_value;
    $[6] = tooltipId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isMobile || $[9] !== meta.data_value || $[10] !== tooltipId) {
    t4 = !isMobile && <Tooltip id={tooltipId} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{meta.data_value}</Tooltip>;
    $[8] = isMobile;
    $[9] = meta.data_value;
    $[10] = tooltipId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t2 || $[16] !== t5) {
    t6 = <div className="tw-flex tw-flex-col tw-gap-y-1 tw-rounded-md tw-bg-iron-800/50 tw-px-2 tw-py-1">{t2}{t5}</div>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default function ParticipationDropMetadata(t0) {
  const $ = _c(14);
  const {
    metadata,
    contextId
  } = t0;
  const [showAllMetadata, setShowAllMetadata] = useState(false);
  if (metadata.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.stopPropagation();
      setShowAllMetadata(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleShowMore = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_0 => {
      e_0.stopPropagation();
      setShowAllMetadata(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleShowLess = t2;
  let t3;
  if ($[2] !== contextId || $[3] !== metadata) {
    let t4;
    if ($[5] !== contextId) {
      t4 = meta => <MetadataItem key={meta.data_key} meta={meta} contextId={contextId} />;
      $[5] = contextId;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = metadata.slice(0, 2).map(t4);
    $[2] = contextId;
    $[3] = metadata;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== contextId || $[8] !== metadata || $[9] !== showAllMetadata) {
    t4 = metadata.length > 2 && (showAllMetadata ? <>{metadata.slice(2).map(meta_0 => <MetadataItem key={meta_0.data_key} meta={meta_0} contextId={contextId} />)}<button onClick={handleShowLess} className="tw-border-0 tw-bg-transparent tw-text-left tw-text-xs tw-font-semibold tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-primary-300">Show less</button></> : <button onClick={handleShowMore} className="tw-border-0 tw-bg-transparent tw-text-left tw-text-xs tw-font-semibold tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-text-primary-300">Show all</button>);
    $[7] = contextId;
    $[8] = metadata;
    $[9] = showAllMetadata;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="tw-hidden tw-border-t tw-border-iron-800/30 tw-px-4 tw-pt-4 sm:tw-ml-[3.25rem] lg:tw-block"><div className="tw-grid tw-grid-cols-2 tw-gap-2 sm:tw-grid-cols-4">{t3}{t4}</div></div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}